import React, { useEffect, useState } from 'react';

import { useFilters } from '../../providers/FiltersProvider';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import client from '../../client/apollo-client';
import { TopicFiltersQuery } from '../../queries/filters';

import FilterButtons from './shared/FilterButtons';

const MAX_TOPICS_FILTER = 100;

const TopicsFilter = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)');

  const [filterTopics, setFilterTopics] = useState([]);
  const { selectedTopics, setSelectedTopics } = useFilters();

  const maxButtonsToShow = isMobile ? filterTopics.length : 4;

  useEffect(() => {
    const fetchTopics = async () => {
      const { data } = await client.query({
        query: TopicFiltersQuery,
        variables: { first: MAX_TOPICS_FILTER },
      });
      const topics = data.topics.nodes.map((node) => ({
        label: node.name,
        value: node.slug,
      }));

      setFilterTopics(topics);
    };

    fetchTopics();
  }, []);

  return (
    <div className="topic-filter flex">
      <FilterButtons
        initialItems={filterTopics}
        label={'Topic'}
        maxButtonsToShow={maxButtonsToShow}
        selectedItems={selectedTopics}
        setSelectedItems={setSelectedTopics}
        showCounter={true}
      />
    </div>
  );
};
export default TopicsFilter;
